import React, { useEffect, useState } from "react";

// Components
import Navbar from "Features/Header/Navbar/Navbar";
// Styles
import "./Header.scss";
import { useLocation } from "react-router-dom";
import { useAppSelector } from "Hooks/useRedux";

const Header = () => {
  const [isMobile, setMobile] = useState(window.innerWidth <= 599);
  const [scroll, setScroll] = useState(0);
  const location = useLocation();
  const isAuthenticated = Boolean(useAppSelector((state) => state.auth.token));

  const handleMobileChange = (isMobile: boolean) => {
    setMobile(isMobile);
  };

  const handleScroll = () => {
    const header = document.getElementById("header_container");
    const currentScroll = window?.scrollY;
    setScroll(currentScroll);
    if (!header) return;

    if (window.scrollY > 50) {
      header.classList.remove("header_container--trasparent");
      header.classList.add("header_container--white");
    } else {
      header.classList.add("header_container--trasparent");
      header.classList.remove("header_container--white");
    }
  };

  useEffect(() => {
    if (location.pathname === "/") {
      window.addEventListener("scroll", handleScroll);
      // Ejecutar al montar por si ya se scrolleó
      handleScroll();
    }

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [location.pathname]);

  // Para otras rutas, fijar el color blanco
  useEffect(() => {
    const header = document.getElementById("header_container");
    if (!header) return;

    if (location.pathname !== "/") {
      header.classList.remove("header_container--trasparent");
      header.classList.add("header_container--white");
    }
  }, [location.pathname]);

  return (
    <div data-testid="header" className="divHead">
      <header
        className={`header_container header_container--trasparent ${
          isAuthenticated ? "short" : ""
        }`}
        id="header_container"
      >
        <Navbar
          onChange={handleMobileChange}
          isMobile={isMobile}
          scroll={scroll}
        />
      </header>
    </div>
  );
};

export default Header;
